///
/// EarthBrowser
///
/// Created by Matt Giger on 2/13/2025
/// Copyright (c) 2025 Geodata Labs
///

import { Database } from "../Database"
import { type PackageAssetStatus } from "@/types/PackageState"

export class AssetStatusTable {

	public static async create(db: Database): Promise<void> {
		await db.execMany([
			{ sql: `create table if not exists asset_status (
				id text primary key,
				version text,
				type text,
				category text,
				state integer
			)` },
			{ sql: 'create index if not exists asset_status_id_version on asset_status (id, version)' },
			{ sql: 'create index if not exists asset_status_type on asset_status (type)' },
		])
	}

	public static async get(id: string, version: string): Promise<PackageAssetStatus | undefined> {
		const result = await Database.db.exec(`select * from asset_status where id = ? and version = ?`, [id, version]) as PackageAssetStatus[]
		return result.length > 0 ? result[0] : undefined
	}

	public static async getTypedStatuses(type: string): Promise<PackageAssetStatus[]> {
		return await Database.db.exec(`select * from asset_status where type = ?`, [type]) as PackageAssetStatus[]
	}

	public static async set(id: string, version: string, state: PackageAssetStatus): Promise<void> {
		await Database.db.exec(`INSERT INTO asset_status (id, version, type, category, state) VALUES (?, ?, ?, ?, ?)
			ON CONFLICT(id) DO UPDATE SET version = excluded.version, type = excluded.type, category = excluded.category, state = excluded.state`,
			[id, version, state.type, state.category, state.state])
	}

	public static async bulkRemove(ids: string[], version: string): Promise<void> {
		await Database.db.exec(`delete from asset_status where id in (${ids.map(() => '?').join(',')}) and version = ?`, [...ids, version])
	}

	public static async update(id: string, version: string, state: PackageAssetStatus): Promise<void> {
		await Database.db.exec(`update asset_status set state = ? where id = ? and version = ?`,
			[state.state, id, version])
	}

	public static async delete(id: string, version: string): Promise<void> {
		await Database.db.exec(`delete from asset_status where id = ? and version = ?`, [id, version])
	}
}
